import { render, staticRenderFns } from "./MatchPair.vue?vue&type=template&id=62f56712&"
import script from "./MatchPair.vue?vue&type=script&lang=js&"
export * from "./MatchPair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports